// deps
import React, { ReactElement, memo } from "react";
import { ONE_BILL_DETAILS_TEST_IDS } from "@swiggy-private/cart-test-ids";

interface OneLogoProps {
    width?: number;
    height?: number;
    className?: string;
}

const OneLogoFull = (props: OneLogoProps): ReactElement => {
    const { height = 11, width = 32, className = "" } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            className={className}
            data-testid={ONE_BILL_DETAILS_TEST_IDS.ONE_LOGO}
        >
            <defs>
                <linearGradient id="sz" x1="3.114" x2="2.279" y1="0.921" y2="7.14" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fff" stopOpacity="0" />
                    <stop offset="1" stopColor="#666066" />
                </linearGradient>
            </defs>
            <path
                fill="url(#sz)"
                d="M3.62 5.97c0-.874.421-1.58 1.182-1.794L3.365 2.844l1.26-1.843C1.696 1.296 0 3.485 0 5.97c0 2.223 1.354 4.226 3.735 4.837l.981-3.05c-.707-.24-1.097-.93-1.097-1.787z"
            />
            <path
                fill="#666066"
                d="M7.003 5.972c0 1.07-.605 1.88-1.701 1.88-.58 0-1.018-.24-1.303-.628l-3.573.808C1.17 9.747 2.864 11 5.303 11c3.365 0 5.32-2.357 5.32-5.03S8.669.964 5.304.964c-.043 0-.086.002-.128.005l-.076.004L5.031 0 2.834 2.852l2.64 2.444V4.121l.032.002c.011 0 .022 0 .033.002.946.109 1.464.876 1.464 1.847zm10.73 4.791V5.476c0-.99-.528-1.366-1.37-1.366-.801 0-1.212.416-1.506.752v5.9h-3.521V1.2h3.52v1.088c.548-.634 1.585-1.327 3.249-1.327 2.191 0 3.15 1.346 3.15 3.01v6.791h-3.522z"
            />
            <path
                fill="#666066"
                fillRule="evenodd"
                d="M21.944 5.972c0-2.771 2.094-5.008 5.145-5.008C29.867.964 32 2.984 32 6.348v.733h-6.416c.196.614.88 1.208 2.035 1.208.528 0 1.701-.258 2.17-.674l1.449 2.198c-.94.81-2.622 1.187-4.03 1.187-2.955 0-5.264-1.88-5.264-5.028zm5.145-2.297c-1.075 0-1.428.712-1.545 1.148h3.11c-.097-.416-.43-1.148-1.565-1.148z"
            />
        </svg>
    );
};

export default memo(OneLogoFull);
